'use client'

// BirdReply — "Pino peeps back at you".
//
// He already answers a walker's mark with one of his own, but a glyph popping
// up over his head is easy to miss and easy to read as decoration. This says
// it in words, just under the middle of the screen, for a few seconds. It's
// the moment someone realises he noticed them, which is the single thing this
// whole world is trying to sell.

import { useEffect, useState } from 'react'
import useGameStore from '../../stores/gameStore'
import { ui } from '../../lib/ui/theme'

const HOLD_MS = 3600

export function BirdReply() {
  const reply = useGameStore((s) => s.birdReply)
  const [shown, setShown] = useState(null)

  useEffect(() => {
    if (!reply) return
    setShown(reply)
    const t = setTimeout(() => setShown(null), HOLD_MS)
    return () => clearTimeout(t)
  }, [reply])

  if (!shown) return null

  return (
    <div className="fixed left-1/2 -translate-x-1/2 z-40 pointer-events-none select-none" style={{ top: '58%' }}>
      <div
        style={{
          padding: '8px 18px',
          borderRadius: ui.radiusPill,
          background: ui.panel,
          border: `1px solid ${ui.accent}55`,
          backdropFilter: ui.blur,
          WebkitBackdropFilter: ui.blur,
          boxShadow: ui.shadow,
          color: ui.text,
          fontFamily: ui.font,
          fontSize: ui.size.md,
          whiteSpace: 'nowrap',
          animation: 'birdreply-in 260ms ease-out',
        }}
      >
        {shown.text}
      </div>
      <style jsx>{`
        @keyframes birdreply-in {
          0% { opacity: 0; transform: translateY(6px) scale(0.96) }
          100% { opacity: 1; transform: translateY(0) scale(1) }
        }
      `}</style>
    </div>
  )
}

export default BirdReply
